import { toast } from "react-hot-toast";

// Toast with custom dismissable message (replacement for `notice`)
export const setToaster = (value) => {
  toast.custom((t) => (
    <div
      className={`account-logout ${t.visible ? "animate-enter" : "animate-leave"}`}
      style={{
        backgroundColor: "#103996",
        color: "#fff",
        padding: "16px",
        borderRadius: "8px",
        width: 450,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>{value}</span>
      <button
        style={{
          marginLeft: 12,
          padding: "8px 12px",
          background: "#fff",
          color: "#103996",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={() => toast.dismiss(t.id)}
      >
        Cancel
      </button>
    </div>
  ));
};

// Confirmation toast (replacement for `check`)
export const checkConform = async (callback, message) => {
  return new Promise((resolve) => {
    const toastId = toast.custom((t) => (
      <div
        className={`account-logout ${t.visible ? "animate-enter" : "animate-leave"}`}
        style={{
          backgroundColor: "#103996",
          color: "#fff",
          padding: "16px",
          borderRadius: "8px",
          width: 500,
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <div>{message}</div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button
            className="my-check-cancel"
            style={{
              backgroundColor: "#ccc",
              color: "#fff",
              padding: "8px 16px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss(toastId);
              resolve(false);
            }}
          >
            No
          </button>
          <button
            style={{
              backgroundColor: "#fff",
              color: "#103996",
              padding: "8px 16px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss(toastId);
              resolve(true);
            }}
          >
            Yes
          </button>
        </div>
      </div>
    ));

    // Optional: auto-close after 15 seconds
    setTimeout(() => {
      toast.dismiss(toastId);
      resolve(false);
    }, 15000);
  })
    .then((isConfirmed) => {
      if (isConfirmed) {
        callback();
      }
    })
    .catch((err) => {
      alert(`Confirmation error: ${err.message}`);
    });
};

// Simple toast (replacement for `toast`)
export const showToaster = (value) => {
  toast.success(value, {
    duration: 2000,
    style: {
      background: "#103996",
      color: "#fff",
    },
  });
};

// Return title if exists
export const renderTitle = (title) => {
  return title || "";
};

// Catch and rethrow error messages
export const catchError = (response) => {
  if (response instanceof Error) {
    throw new Error(response.response?.data?.message || "An error occurred");
  }
};
